import React from 'react';
import PropTypes from 'prop-types';

import Popup from '../../Popup';

import styles from './confirmStartMatchPopup.scss';

const ConfirmStartMatchPopup = (props) => {
    const {
        onCloseClick,
        onConfirmStart,
    } = props;

    return (
        <Popup
            className="popup-sm"
            popUpClassName={styles.confirmStartMatchPopup}
            onCloseClick={onCloseClick}
            closeOnClickOutside={false}
            config={{
                fullScreen: false,
                noPadding: false,
                scrollable: false,
                showCloseIcon: false,
            }}
        >
            <div className={styles.header}>
                Start selected matches?
            </div>
            <div className={`${styles.description} mt8`}>
                {'An "In Progress" label will appear on selected match cards.'}
            </div>
            <div className={`${styles.description} mt8`}>
                If SMS is enabled, players will receive a text notification. To edit SMS settings, go to the manage section.
            </div>
            <div className={`${styles.footer} d-flex`}>
                <button
                    className={'btn btn-default mr8 flex-1'}
                    type="button"
                    onClick={onCloseClick}
                >
                    No, Cancel
                </button>
                <button
                    className={`btn btn-primary flex-1`}
                    type="button"
                    onClick={onConfirmStart}
                >
                    Yes, Start
                </button>
            </div>
        </Popup>
    );
};

ConfirmStartMatchPopup.propTypes = {
    onCloseClick: PropTypes.func.isRequired,
    onConfirmStart: PropTypes.func.isRequired,
};

ConfirmStartMatchPopup.defaultProps = {
};

export default ConfirmStartMatchPopup;
